/**
 * Appointment tags: per-location labels (name + optional emoji) attached to an
 * appointment (the transaction). Backend: bookings-infra
 * `core/endpoints/appointment_tags/` (see its docs/APPOINTMENT_TAGS.md).
 */

/** Max tag name length (backend `MAX_TAG_NAME_LENGTH`, after trim). */
export const MAX_APPOINTMENT_TAG_NAME_LENGTH = 50;
/** Max emoji string length (backend `MAX_TAG_EMOJI_LENGTH`, code points). */
export const MAX_APPOINTMENT_TAG_EMOJI_LENGTH = 32;

/**
 * One active tag, as served by the catalog GET and embedded in every `tags[]`
 * on transaction reads. `emoji` null = render the default tag icon.
 */
export interface AppointmentTag {
  id: string;
  name: string;
  emoji: string | null;
  sort_order: number;
}

/** `POST /business-locations/{id}/appointment-tags`; omit sort_order to append. */
export interface CreateAppointmentTagRequest {
  name: string;
  emoji?: string | null;
  sort_order?: number;
}

/** `PUT /appointment-tags/{tag_id}`: partial; `emoji: null` clears it. */
export type UpdateAppointmentTagRequest = Partial<CreateAppointmentTagRequest>;
